/* 引入基础设施 */
import routerGenerator from "@/common/router/routerGenerator";

/* 引入组件 */
import index from "@/pages/main/index/index.vue";
import home from "@/pages/main/home/home.vue";
import about from "@/pages/main/about/about.vue";
import products from "@/pages/main/products/products.vue";
import cases from "@/pages/main/cases/cases.vue";
import member from "@/pages/main/member/member.vue";

// 主页路由 - 作为官网首页
let indexRouter = routerGenerator.root("公司首页", "Index", "/", index, [
  // 首页内容
  routerGenerator.leaf("首页", "Home", "/", home),
  // 关于我们
  routerGenerator.leaf("关于我们", "About", "/about", about),
  // 产品服务
  routerGenerator.leaf("产品服务", "Products", "/products", products),
  // 客户案例
  routerGenerator.leaf("客户案例", "Cases", "/cases", cases),
  // 会员中心
  routerGenerator.leaf("会员中心", "Member", "/member", member),
]);

export default [
  // 主页路由
  indexRouter,
  // 重定向所有未匹配的路由到首页
  { path: "*", redirect: "/" },
];
